import { createContext, use, type ReactNode } from 'react';

export interface ChartContextModel {
	patientId: string;
	stayId: string;
	certificationPeriodId: string;
	workflowStageTaskId?: string;
}

const ChartContext = createContext<ChartContextModel | null>(null);

export function ChartContextProvider({
	children,
	...props
}: {
	patientId: string;
	stayId: string;
	certificationPeriodId: string;
	workflowStageTaskId?: string;
	children: ReactNode;
}) {
	return <ChartContext value={props}>{children}</ChartContext>;
}

export function useChart() {
	const context = use(ChartContext);
	if (!context) {
		throw new Error('useChart must be used within a ChartContextProvider');
	}
	return context;
}
